import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { customStylesForTesting } from '../../../../../Components/helper';

export function FontSizeConfig({ obj, handleFontSize, dataName }) {
  const { t } = useTranslation('common');

  const options = [
    { value: '11px', label: '11 px' },
    { value: '13px', label: '13 px' },
    { value: '15px', label: '15 px' },
    { value: '17px', label: '17 px' },
    { value: '25px', label: '25 px' },
  ];

  const foundOption = options.find((ele) => ele.value === obj?.otherConfiguration?.[dataName]);

  return (
    <div className="common-react-select w-150">
      <p className="field-name">Font Size</p>
      <Select
        name="fontSize"
        options={options}
        value={foundOption}
        styles={customStylesForTesting}
        className="common-select"
        classNamePrefix="common-select"
        onChange={(e) => handleFontSize(e, dataName)}
        placeholder={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.FONT_CONFIG.FONT_SIZE')}
        menuPosition="fixed"
      />
    </div>
  );
}

export default FontSizeConfig;
